export default "__VITE_ASSET__MhVyyk_X__"